<template>
  <v-banner color="info" class="mb-2">
    <a :href="getConverterUrl" target="_blank">
      {{ $t('converter.link') }}
    </a>
  </v-banner>
</template>

<script lang="ts">
export default {
  computed: {
    getConverterUrl() {
      return window?.location?.host?.includes('stage')
        ? 'https://xsd-converter.stage.vers-tool.eu/'
        : 'https://xsd-converter.vers-tool.eu/';
    },
  },
};
</script>